import { ServiceMaker, methods, services } from "@/services";

export const listBlogs = () =>
    ServiceMaker(`/social/post/my-posts`, methods.GET, services.master);

export const getBlogById = (id) =>
    ServiceMaker(`/social/post/view-post/${id}`, methods.GET, services.master);

export const createBlog = (data) =>
    // /post/create-post
    ServiceMaker(
        `/social/post/create-post`,
        methods.POST,
        services.master,
        data,
    );

export const updateBlog = (id, data) =>
    ServiceMaker(`/social/post/edit/${id}`, methods.PUT, services.master, data);

export const deleteBlog = (id) =>
    ServiceMaker(
        `/social/post/delete-post/${id}`,
        methods.DELETE,
        services.master,
    );
